<template>
  <div class="OffPage">
      <div class="container">
        <div class="row text-right" dir="rtl">
          <ul class="bread-crumb">
            <li class="bread-crumb-item"><router-link to="/">نوراشاپ</router-link> / </li>
            <li class="bread-crumb-item"><router-link to="/off">موجودی محدود</router-link></li>
          </ul>
        </div>
        <ImageSlider :images="response.sliders" class="d-none d-md-block mt-3" />
        <ImageSliderMobile :images="response.sliders" class="d-block d-md-none my-3" />

        <h1 class="text-center my-4">موجودی محدود</h1>
        <ul class="nav nav-tabs mb-4" id="myTab" role="tablist">
          <li class="nav-item" role="presentation" :key="(category,index)" v-for="(category,index)  in categories">
            <label  @click="category.OffPageNav = !category.OffPageNav;addFilter('c', categories.filter((x) => { return x.OffPageNav }).map((x) => { return x.id }));" class="nav-link" :class="category.OffPageNav ? 'active' : ''" >{{category.name}}</label>
          </li>
        </ul>

        <ProductFiltering :brands="$categories.map((x) => x.brands).flatMap((element) => element).flat(2)" :categories="$categories" class="mb-4" />

        <div class="row justify-content-center">
          <template :key="(product,index)" v-for="(product,index) in products">
            <transition name="fade" mode="out-in">
              <ProductCard :obj="product" v-if="index < paginator" />
            </transition>
          </template>
        </div>

        <div class="row justify-content-center" v-if="firstLoading">
          <template :key="(product,index)" v-for="(product,index) in 10">
            <transition name="fade" mode="out-in">
              <ProductCard :obj="null" v-if="index < paginator" />
            </transition>
          </template>
        </div>

        <div class="load-more">
          <button aria-label="بیشتر" :disabled="!loadMore" class="btn btn-secondary my-4" @click="paginator += 10">بیشتر</button>
        </div>

        <PageContent mode="OffPage" />
      </div>
  </div>
</template>
<script>
import ImageSlider from '@/components/ImageSlider.vue'
import ImageSliderMobile from '@/components/ImageSliderMobile.vue'
import ProductCard from '@/components/ProductCard.vue'
import ProductFiltering from '@/components/ProductFiltering.vue'
import PageContent from '@/components/PageContent.vue'

export default {
  name: 'OffPage',
  components: {
    ImageSlider,
    ImageSliderMobile,
    ProductCard,
    ProductFiltering,
    PageContent
  },
  data () {
    return {
      response: {},
      products: [],
      paginator: 10,
      loadMore: true,
      firstLoading: true,
      categories: this.$categories
    }
  },
  methods: {
    loadProduct: function () {
      this.loadMore = false
      const query = `
{
  products(
    filters: {
    count: 10
    haveOff: true
    order: "-OFF"
    available: true
    exclude: "${this.products.map(item => item.id)}"
    ${this.$route.query.orginal ? `orginal: ${this.$route.query.orginal}` : ''}
    ${this.$route.query.age ? `age: "${this.$route.query.age}"` : ''}
    ${this.$route.query.brands ? `brands: "${this.$route.query.brands}"` : ''}
    ${this.$route.query.priceGteLte ? `priceGteLte: "${this.$route.query.priceGteLte}"` : ''}
    ${this.$route.query.gender ? `gender: ${this.$route.query.gender}` : ''}
    }
  ) {
    id
    available
    slug
    name
    image: PNG
    mlActivation
    specialTag
    concepts:concepts{
      id
      price
      name
      video
      videoCover
      image
      description
    }
    isOffInt
    priceAfterOff
    priceBeforeOff
    categorySlug
    subCategorySlug
    categoryId
  }
  meta(key:"${this.$options.name}") {
    seoTitle
    seoKeyword
    seoDescription
  }
  sliders (key: "OffPage") {
    imageMobile
    image
    alt
    link
  }
}
      `
      this.$fetchGraphQL(query)
        .then((response) => {
          this.response = response.data
          this.setMetaByObj(response.data.meta)
          this.firstLoading = false
          if (response.data.products.length === 0) {
            this.loadMore = false
          } else {
            this.loadMore = true
          }
          for (const x in response.data.products) {
            this.products.push(response.data.products[x])
          }
        })
    },
    pageLoad: function () {
      this.products = []
      this.loadProduct()
    }
  },
  mounted () {
    this.pageLoad()
    this.emitter.on('updateFilters', isOpen => { this.pageLoad() })
  },
  watch: {
    paginator (to, from) {
      this.loadProduct()
    },
    '$route.query' (to, from) {
      if (this.$route.path.slice(1, 9) === 'off') {
        this.pageLoad()
      }
    }
  }
}
</script>

<style scoped>
.load-more{
  display: flex;
  justify-content: center;
}
button{
  width: fit-content;
  padding: 7px 95px;
  border-radius: 24px;
  transition: 0.4s;
}
.btn-check:active+.btn-secondary, .btn-check:checked+.btn-secondary, .btn-secondary.active, .btn-secondary:active, .show>.btn-secondary.dropdown-toggle {
    color: #000;
    background-color: #86e9fc;
    border-color: #86e9fc;
}
.btn-secondary:hover {
    color: #000;
    background-color: #86e9fc;
    border-color: #86e9fc;
}
.btn-check:focus+.btn-secondary, .btn-secondary:focus {
    color: #000;
    background-color: #86e9fc;
    border-color: #86e9fc;
    box-shadow: none;
}
.nav-link{
  color: #bdbdbd;
}
.nav{
  justify-content: center;
}
.nav-link:hover{
  border-color: transparent;
}
.nav-item{
  filter: drop-shadow(0px 2px 5px rgba(50, 50, 0, 0.2));
  margin: 5px 0px;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active{
  color: black;
  background-color: #e8acd4;
  border-color: transparent;
  clip-path: polygon(20% 0%, 100% 0%, 100% 50%, 100% 100%, 0% 100%, 0% 50%);
}
.nav-tabs{
  border:none;
}

.nav-link{
    border: solid #e8acd4 2px;
    color: black;
    padding: 6px 10px;
    border-radius: 24px;
    width: max-content;
    transition: 0.4s;
}
.nav-link:hover{
    background-color: #e8acd4;
    color: black;
    padding: 6px 13px;
    border-radius: 24px;
    width: max-content;
}

</style>
